import React from 'react';

export default class Page6 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToCreateTeamIdentity');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="desktop ilead-model">

                                                <table border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                    <tbody>
                                                    <tr>

                                                    </tr>
                                                    <tr>
                                                        <td align="left" valign="top" width="10%"><img
                                                            src={require('@images/commitimg.png')}
                                                            align="center" className="tableimage"/>
                                                        </td>
                                                        <td align="left" valign="top" style={{paddingLeft:'20px'}}>
                                                            <div className="border_subtitle">Commitment</div>
                                                            <p>Should you find commitment flagging, try to find
                                                                out why at the earliest opportunity – don’t just
                                                                leave it to sort itself out, because the chances
                                                                are it won’t. Talk to those you think are losing
                                                                commitment because they will give you the
                                                                quickest diagnosis of any ‘issues’. It may be
                                                                something pertinent to them and their approach
                                                                to work; it may be that progress is slow and
                                                                momentum needs to be increased. It may be that
                                                                people don’t see that you are committed, perhaps
                                                                because you’ve cancelled meetings, or appear to
                                                                pay only cursory attention to developments.
                                                                Whatever it is, identify it fast, because both
                                                                commitment and loss of commitment are
                                                                contagious.</p>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="mobile ilead-model">

                                                <table border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                    <tbody>
                                                    <tr>

                                                    </tr>
                                                    <tr>
                                                        <td align="left" valign="top" width="30%"><img
                                                            src={require('@images/commitimg.png')}
                                                            align="center" className="tableimage"/>
                                                        </td>
                                                        <td align="left" valign="top" style={{paddingLeft:'20px'}}>
                                                            <div className="border_subtitle">Commitment</div>
                                                            <p>Should you find commitment flagging, try to find
                                                                out why at the earliest opportunity – don’t just
                                                                leave it to sort itself out, because the chances
                                                                are it won’t. Talk to those you think are losing
                                                                commitment because they will give you the
                                                                quickest diagnosis of any ‘issues’. It may be
                                                                something pertinent to them and their approach
                                                                to work; it may be that progress is slow and
                                                                momentum needs to be increased. It may be that
                                                                people don’t see that you are committed, perhaps
                                                                because you’ve cancelled meetings, or appear to
                                                                pay only cursory attention to developments.
                                                                Whatever it is, identify it fast, because both
                                                                commitment and loss of commitment are
                                                                contagious.</p>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="circle_title"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>SUMMARY</div>
                                            <p>Whatever situation you find yourself in when having to create a
                                                team, take the time to really
                                                consider the important elements involved, as we’ve described
                                                them. It doesn’t have to be an
                                                arduous process. By factoring in as many parts of the jigsaw as
                                                possible you’ll have every chance
                                                of success. Good luck!</p>

                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">Further Information</span>
                                            </div>

                                            <div className="paraspace"><p>If you found this tool useful then you
                                                are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToMotivateOthers')}>How
                                                        to motivate others</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToRaiseEnergyLevels')}>How
                                                        to raise energy levels</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToDevelopRapport')}>How
                                                        to develop rapport</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToBuildAndMaintainTrust')}>How
                                                        to build and maintain trust</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToEngageOthersToDeliver')}>How
                                                        to engage others to deliver.</div></li>
                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>REFERENCES</div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Fitousi,
                                                    D., &amp; Wenger, M. J. (2011). Processing capacity under
                                                    perceptual and cognitive load: A closer look at load theory.<span
                                                        className="subtiltereg">  Journal of Experimental Psychology: Human Perception and Performance,</span> 37(3),
                                                    781.</p></li>
                                                <li><p className="further_info_content">Tajfael, H. (1978) (Ed.)<span
                                                    className="subtiltereg">  Differentiation Between Social Groups: Studies in the Social Psychology of Intergroup Relations.</span> London:
                                                    Academic Press</p></li>
                                                <li><p className="further_info_content">Simon,
                                                    B., &amp; Pettigrew, T. F. (2012). Social identity and
                                                    perceived group homogeneity: Evidence for the ingroup
                                                    homogeneity effect.<span className="subtiltereg">  European Journal of Social Psychology, 20(4),</span> 269-286.
                                                </p></li>
                                                <li><p className="further_info_content">Turner, J. et al (1987).<span
                                                    className="subtiltereg">  Rediscovering the social group: A self-categorization theory.</span> Oxford:
                                                    Blackwell.</p></li>
                                            </ol>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page7')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('People')}
                                                    className="button-next-previous-done">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }